<template>
    <a :href="href"
       :target="target"
       v-on:click="productClicked">
        <slot />
    </a>
</template>
<script>
    export default {
        name: 'dm-link',
        props: {
            href: {
                type: String,
                required: false,
            },
            target: {
                type: String,
                required: false,
            }
        },
        methods: {
            productClicked(e) {
                e.preventDefault();
                this.$emit('product-clicked', e);
            }
        }
    };
</script>
